import { useState } from "react";
import { Button, Card, Table } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Select from "react-select";
import Loader from "../../../common/Loader";
import NoData from "../../../common/NoData";
import Pagination from "../../../common/Pagination/Pagination";
import { Translate } from "../../../Enums/Tranlate";
import CardItem from "./CardItem";
import OrganizationService from "../../../../services/HRM/OrganizationService";

const sortByOptions = [
	{ label: "Name", value: "name" },
	{ label: "Created At", value: "createdAt" },
];

const sortOrderOptions = [
	{ label: "Ascending", value: "asc" },
	{ label: "Descending", value: "desc" },
];

const Organization = () => {
	const [data, setData] = useState([]);
	const [hasData, setHasData] = useState(null);
	const [search, setSearch] = useState("");
	const [shouldUpdate, setShouldUpdate] = useState(false);
	const [loading, setLoading] = useState(false);
	const [sortBy, setSortBy] = useState(null);
	const [sortOrder, setSortOrder] = useState(null);
	const Auth = useSelector((state) => state.auth?.auth);
	const isExist = (data) => Auth?.admin?.admin_roles?.includes(data);
	const lang = useSelector((state) => state.auth?.lang);

	const param = {
		...(sortBy ? { sortBy: sortBy.value } : {}),
		...(sortOrder ? { sortOrder: sortOrder.value } : {}),
	};

	return (
		<div className="admin">
			<Card className="mb-3">
				<Card.Body className="d-flex justify-content-between p-3 align-items-center gap-2">
					<div className="d-flex align-items-center" style={{ gap: "8px" }}>
						<div className="input-group">
							<input
								type="text"
								style={{
									borderRadius: "8px",
									color: "initial",
									padding: "18px 16px",
								}}
								className="form-control"
								placeholder={`${Translate[lang]?.search_by} ${Translate[lang]?.name}`}
								value={search}
								onChange={(e) => setSearch(e.target.value)}
							/>
							<div
								className="flaticon-381-search-2"
								style={{
									position: "absolute",
									zIndex: "1",
									right: lang === "en" && "16px",
									left: lang === "ar" && "16px",
									top: "50%",
									transform: "translate(0, -50%)",
								}}
							/>
						</div>

						<div style={{ minWidth: "190px" }}>
							<Select
								isClearable
								placeholder={Translate[lang]?.sort_by || "Sort By"}
								options={sortByOptions}
								value={sortBy}
								onChange={(e) => {
									setSortBy(e);
									setShouldUpdate((p) => !p);
								}}
							/>
						</div>
						<div style={{ minWidth: "190px" }}>
							<Select
								isClearable
								placeholder={Translate[lang]?.sort_order || "Sort Order"}
								options={sortOrderOptions}
								value={sortOrder}
								onChange={(e) => {
									setSortOrder(e);
									setShouldUpdate((p) => !p);
								}}
							/>
						</div>
						<Button
							variant="primary"
							className="ms-1"
							onClick={() => setShouldUpdate((p) => !p)}>
							{Translate[lang]?.search}
						</Button>
					</div>
					<div className="d-flex gap-2 align-items-center">
						{/* {isExist("add_organization") && ( */}
						<Link
							to="/organization/add-organization"
							className="btn btn-primary">
							<i className="la la-plus mx-1"></i>
							{Translate[lang]?.add} {Translate[lang]?.organization}
						</Link>
						{/* )} */}
					</div>
				</Card.Body>
			</Card>

			<Card>
				<Card.Body className={`${hasData === 0 ? "text-center" : ""}`}>
					{loading && (
						<div style={{ height: "300px" }}>
							<Loader />
						</div>
					)}
					{hasData === 1 && !loading && (
						<Table responsive>
							<thead>
								<tr className="text-center">
									<th>
										<strong>{Translate[lang]?.name}</strong>
									</th>
									<th>
										<strong>
											{Translate[lang]?.additional_names || "Additional Names"}
										</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.date || "Date"}</strong>
									</th>
									<th></th>
								</tr>
							</thead>
							<tbody>
								{data?.map((item, index) => (
									<CardItem
										key={item.id || index}
										index={index}
										item={item}
										setShouldUpdate={setShouldUpdate}
									/>
								))}
							</tbody>
						</Table>
					)}
					{hasData === 0 && <NoData />}
					<Pagination
						setData={setData}
						service={new OrganizationService()}
						shouldUpdate={shouldUpdate}
						setHasData={setHasData}
						setLoading={setLoading}
						search={search}
						param={param}
					/>
				</Card.Body>
			</Card>
		</div>
	);
};

export default Organization;
